import { Link } from 'react-router-dom';
import { Fragment } from 'react';

/**
 * MentionText — render text that may contain `@[Display Name](user_id)`
 * mentions. Each mention becomes a clickable Link to the member's profile.
 * Everything else renders as plain text with whitespace preserved.
 *
 * Usage: <MentionText text={post.content} />
 */
const MENTION_RE = /@\[([^\]]+)\]\(([^)]+)\)/g;

export default function MentionText({ text, className = '' }) {
  if (!text) return null;
  const parts = [];
  let lastIndex = 0;
  let match;
  let i = 0;
  while ((match = MENTION_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(<Fragment key={`t${i++}`}>{text.substring(lastIndex, match.index)}</Fragment>);
    }
    parts.push(
      <Link
        key={`m${i++}`}
        to={`/profile/${match[2]}`}
        className="text-emerald-700 font-medium hover:underline"
        onClick={(e) => e.stopPropagation()}
      >
        @{match[1]}
      </Link>
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push(<Fragment key={`t${i++}`}>{text.substring(lastIndex)}</Fragment>);
  }
  return <span className={className} style={{ whiteSpace: 'pre-wrap' }}>{parts}</span>;
}
